<template>
  <div>
    <h1 v-if="member.mobile" class="mt-3 p-3 bg-faded">
      <img
        class="profile-image-md rounded-circle"
        :src="member.icon != '' ? member.icon : require('@/assets/image/icon/profile.png')" />
      &nbsp;&nbsp;&nbsp;
      <b>{{ member.name }}</b>
      &nbsp;&nbsp;&nbsp;
      {{ member.mobile }}
    </h1>

    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag m-3" v-if="!isSpinnerShow && member.mobile && items.length == 0">
      {{ $t("table.no_records") }}
    </div>
    <div class="dataTables_wrapper dt-bootstrap4 pt-3 pl-6 pr-6">
      <div class="row">
        <div
          v-for="item in items"
          class="col-6 col-sm-4 col-md-3 col-lg-2 p-2 mb-2"
          :key="'item' + item.id">
          <!-- :title="item.title" -->
          <b-card
            :img-src="item.url"
            img-alt="Image"
            img-top
            img-width="100px"
            img-height="200px"
            tag="article"
            style="border-radius:25px;"
            @click="onFormClick(item)">
            <b-card-text>
              {{ item.title }}
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div>

    <h1 v-if="member.mobile" class="mt-3 p-3 bg-faded">
      Form List
    </h1>

    <div class="panel-tag m-3" v-if="!isSpinnerShow && member.mobile && forms.length == 0">
      {{ $t("table.no_records") }}
    </div>
    <div class="dataTables_wrapper dt-bootstrap4 pt-3 pl-6 pr-6">
      <div class="row">
        <div
          v-for="form in forms"
          class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2 p-2 mb-2"
          :key="'form' + form.consentID">
          <!-- :title="item.title" -->
          <b-card
            :img-src="form.url"
            img-alt="Image"
            img-top
            img-width="100px"
            img-height="200px"
            tag="article"
            style="border-radius:25px;"
            @click="onSignClick(form)">
            <b-card-text>
              {{ form.title }}
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div>

    <br>
    <br>

  </div>
</template>
<script>
import moment from "moment";
import {
  handleSessionExpired,
  setReturnData,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "ConsentFormView",
  data() {
    return {
      isSpinnerShow: false,
      filterObj: {},
      outlet: [],

      member: {},
      items: [],
      exportData: [],
      forms: [],

      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
    };
  },
  computed: {
    exportField() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.username").toUpperCase()] = "username";
      ret[this.$i18n.t("table.header.outlet").toUpperCase()] = "outlet";
      ret[this.$i18n.t("table.header.working_hour").toUpperCase()] = "duration";
      ret[this.$i18n.t("table.header.clock_in").toUpperCase()] = "entryDate";
      ret[this.$i18n.t("table.header.clock_out").toUpperCase()] = "exitDate";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.setExportData(this.exportData);
    },
  },
  methods: {
    async setItems(member) {
      this.member = member
      this.isSpinnerShow = true;

      let $vm = this;
      await $vm.$axios({
        method: "get",
        url: 'https://member.tunai.io/business/member/' + member['memberID'] + '/mconsent',
        headers: { token: $vm.$session.get("token") },
      })
        .then((response) => {
          console.log(response.data)
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      await $vm
        .$axios({
          method: "get",
          url: 'https://bebusiness.tunai.io/consent',
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.forms = response.data.consents
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.isSpinnerShow = false;
    },

    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.setItems(this.filterObj);
      }
    },
    onFormClick(item) {
      console.log(this.member)
      this.$emit('onFormClick', this.member, item)
    },
    onSignClick(item) {
      this.$emit('onSignClick', this.member, item)
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);

    // this.setItems()
  },
};
</script>
